<template>
  <v-card flat class="sub-site-wrapper">
    <div class="chart-component-wrapper">
      <div class="statistics-meta">
        <p>Gesamt Agenturen: {{ totalAgencies }}</p>
        <p>Gesamt Kunden: {{ totalCustomers }}</p>
        <p>Gesamt Nachrichten: {{ totalMessages }}</p>
        <p>Datensatz erstellt am: {{ statisticsAge }}</p>
      </div>
      <div class="chart-controls">
        <v-btn-toggle variant="outlined" rounded="lg" v-model="chartType">
          <v-btn value="bar">Bar</v-btn>
          <v-btn value="line">Line</v-btn>
          <v-btn value="area">Area</v-btn>
          <v-btn value="pie">Pie</v-btn>
        </v-btn-toggle>
      </div>
      <div class="charts-wrapper">
        <apexchart
          v-if="!loading && chartData"
          :key="chartType"
          :type="chartType"
          height="600"
          :options="chartOptions"
          :series="chartSeries"
        >
        </apexchart>
        <p v-else-if="loading">Loading...</p>
        <p v-else>No data available</p>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import VueApexCharts from "vue3-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      chartType: "bar", // Default chart type
    };
  },
  computed: {
    ...mapState("statistics", [
      "whatsAppMessagesPerAgencyCustomer",
      "loading",
      "statisticsAge",
    ]),
    chartData() {
      if (
        !this.whatsAppMessagesPerAgencyCustomer ||
        !this.whatsAppMessagesPerAgencyCustomer.chartData
      ) {
        return null;
      }
      return this.whatsAppMessagesPerAgencyCustomer.chartData;
    },
    totalAgencies() {
      return this.whatsAppMessagesPerAgencyCustomer?.totalAgencies || 0;
    },
    totalCustomers() {
      return this.whatsAppMessagesPerAgencyCustomer?.totalCustomers || 0;
    },
    totalMessages() {
      return this.whatsAppMessagesPerAgencyCustomer?.totalMessages || 0;
    },
    chartSeries() {
      if (!this.chartData) return [];
      const values = Object.values(this.chartData);
      // Handle series format for pie chart separately
      return this.chartType === "pie"
        ? values
        : [
            {
              name: "Nachrichten",
              data: values,
            },
          ];
    },
    chartOptions() {
      if (!this.chartData) return {};
      const categories = Object.keys(this.chartData);
      return {
        chart: {
          type: this.chartType, // Use dynamic chart type
          toolbar: {
            show: true,
          },
        },
        colors:
          this.chartType === "pie"
            ? [
                "#783597",
                "#FF5733",
                "#C70039",
                "#900C3F",
                "#581845",
                "#FFC300",
                "#DAF7A6",
                "#FF5733",
                "#C70039",
                "#900C3F",
                "#581845",
                "#56BAEC",
                "#B6D7F2",
                "#8A2BE2",
                "#7FFF00",
                "#D2691E",
              ]
            : ["#783597"],
        xaxis:
          this.chartType !== "pie"
            ? {
                categories: categories,
                labels: {
                  rotate: -45,
                  rotateAlways: true,
                  style: {
                    fontSize: "10px",
                  },
                },
              }
            : undefined,
        labels: this.chartType === "pie" ? categories : [],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        title: {
          text: "WhatsApp Nachrichten pro Agentur-Kunde",
          align: "center",
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " Nachrichten";
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-controls {
  display: flex;
  justify-content: center;
  margin: 20px auto;
}

.chart-component-wrapper {
  background-color: white;
  margin: 12px 0;
  padding: 12px;
  border-radius: 12px;
}

.statistics-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.statistics-meta p {
  margin: 0;
  font-weight: 500;
}

.charts-wrapper {
  min-height: 400px;
}
</style>












